function NOOP() {}

let nativeBridge;

function constructMessage(commandName, params, callback) {
    //
    const message = {
        commandName,
        params,
        callBack: callback
    };
    return message;
}

function handleCallback(callback, data, err) {
    // Incoming callback can be either a function or a string - handle either
    if (typeof callback === 'function') {
        callback(data, err);
    } else if (typeof callback === 'string') {
        window[callback](data, err);
    }
}

export class NativeBridge {
    constructor({ globalNS } = { globalNS: 'espn.nativeBridge' }) {
        this.isProcessing = false;
        this.processId = null;
        this.messageQueue = [];
        this.globalNS = globalNS;
        this.ns = globalNS.split('.').reduce((acc, ns) => {
            acc[ns] = acc[ns] || {};
            return acc[ns];
        }, window);
        const qs = {};
        location.search.replace(/([^?=&]+)(=([^&#]*))?/g, ($0, $1, $2, $3) => { qs[$1] = $3; });
        this.isIOS = qs.platform === 'ios';
        this.isAndroid = qs.platform === 'android';
        this.isWindows = qs.platform === 'windows';
        // this.sendMessageAsPromise = Promise.promisify(this.sendMessage);
        // this.getDataAsPromise = Promise.promisify(this.getData);
    }

    _processQueue() {
        if (this.isProcessing) {
            return;
        }
        this.isProcessing = true;
        setTimeout(this._processMessages.bind(this), 0);
    }

    _processMessages() {
        const message = this.messageQueue.shift();
        if (message) {
            const { callBack } = message;

            try {
                this._createCallback(callBack);
                this._transmitMessage({ ...message, callBack: `${this.globalNS}.callback` });
            } catch (err) {
                console.error(`NativeBridge: error - _processMessages ${err.message}`);
                this._next(callBack, null, err);
            }

            if (!this.messageQueue.length) {
                this.isProcessing = false;
            }

            // WINDOWS ONLY
            // Windows Devices do NOT trigger a callback (custom or espn.nativeBridge.callback)
            // If still processing (messageQueue is NOT empty), we will set a short timer to manually trigger
            // the callback and call _processMessges method until processing is complete.
            if (this.isProcessing && this.isWindows) {
                this.processId = setTimeout(this._processMessages.bind(this), 200);
            }
        }
    }

    _createCallback(callback) {
        // The purpose is to create "chaining" of the native messages since they unfortunately
        // have to share a singular global callback. But this enables us to pass callbacks as functions vs strings.
        this.ns.callback = (data) => {
            this._next(callback, data);
        };
    }

    _next(callback, data, err) {
        // if callback is triggered, clear timeout to remove duplicate call
        if (this.processId) {
            clearTimeout(this.processId);
            this.processId = null;
        }
        if (callback) {
            if (err) {
                handleCallback(callback, null, err);
            } else {
                try {
                    handleCallback(callback, data);
                } catch (err2) {
                    handleCallback(callback, null, err2);
                }
            }
        }
        if (this.messageQueue.length) {
            this._processMessages();
        } else {
            this.ns.callback = NOOP; // reset
        }
    }

    _transmitMessage(message) {
        if (typeof message === 'undefined') {
            return;
        }

        // console.log('NativeBridge: _transmitMessage');

        if (typeof window.webkit !== 'undefined') { // iOS, looking for WKWebview injected handler
            window.webkit.messageHandlers.espnWebview.postMessage(message);
            return;
        }

        const data = JSON.stringify(message);
        if (this.isAndroid && window.linklanguage) {
            // Android
            window.linklanguage.sendJSONMessage(data);
        } else if (this.isWindows) {
            // Windows
            window.external.notify(data);
        } else if (this.isIOS) {
            // fallback for backwards compatibility
            window.location = data;
        } else {
            console.log("NativeBridge: message sent with", message);
        }
    }

    _sendMessage(message) {
        this.messageQueue.push(message);
        this._processQueue();
    }

    getData(dataName, callback) {
        // Provided as a fallback for backwards compatibility
        const { native } = window.espn;
        if (typeof native !== 'undefined') {
            if (native[dataName] === 'true' || native[dataName] === 'false') {
                // convert boolean string to boolean
                native[dataName] = (native[dataName] === 'true');
            }
            callback(native[dataName]);
            return;
        }

        this.sendMessage(dataName, {}, callback);
    }

    sendMessage(message, params, callback) {
        this._sendMessage(constructMessage(message, params, callback));
    }

    loadMinibrowser(url) {
        if (this.isAndroid) {
            try {
                window.linklanguage.loadMinibrowserWithURL(url);
            } catch (err) {
                console.warn('nativeBridge send failed', url);
            }
        } else {
            this.sendMessage('loadMinibrowserWithURL', { url, link: url });
        }
    }
}

export default function createNativeBridge(config) {
    if (!nativeBridge && typeof window !== 'undefined') {
        nativeBridge = new NativeBridge(config);
    }
    return nativeBridge;
}



// WEBPACK FOOTER //
// ./app/lib/native-bridge/index.js